Vue.component('ack-workflow-cards-section', {
	delimiters: ['${', '}$'],
	template: '#ack-workflow-cards-section',
	props: {
		isVisible: {
			type: Boolean,
			required: false,
			default: true,
		},
		title: {
			type: String,
			required: false,
			default: '',
		},
		sectionData: {
			type: Object,
			required: true,
		},
		sectionClass: {
			type: String,
			required: false,
			default: '',
		},
		titleClass: {
			type: String,
			required: false,
			default: '',
		},
	},
	computed: {
		displayTitle() {
			return this.title || this.sectionData?.title || '';
		},
		cardColumnClass() {
			if (this.sectionData && this.sectionData.layout === 'three-columns') {
				return 'col-12 col-md-6 col-xl-4';
			}

			if (this.sectionData && this.sectionData.layout === 'four-columns') {
				return 'col-12 col-md-6 col-xl-3';
			}

			return 'col-12 col-md-6 col-xl-4';
		},
	},
});
